module.exports = __webpack_public_path__ + "img/HTML-logo.5434d656.svg";